import { NgModule } from '@angular/core';
import { GenesysSecureFrameComponent } from './genesys-secure-frame.component';

@NgModule({
  declarations: [GenesysSecureFrameComponent],
  exports: [GenesysSecureFrameComponent]
})
export class GenesysSecureFrameModule {}
